// Charge toutes les pages d'une liste destinée à un menu de sélection.
//
// Les menus cherchent dans ce qu'ils ont reçu : avec `page_size: 200`, le
// deux-cent-unième chauffeur n'existait pas pour la recherche. Ici on enchaîne
// les pages jusqu'à la dernière, avec trois arrêts : page incomplète, total
// atteint, ou page sans aucune ligne nouvelle — certains endpoints (convois,
// camions, mode hors ligne) ignorent `page` et renvoient tout à chaque appel.
export async function fetchAllPages(getPage, { pageSize = 500, maxPages = 40 } = {}) {
  const seen = new Set();
  const items = [];
  for (let page = 1; page <= maxPages; page += 1) {
    const result = await getPage({ page, page_size: pageSize });
    const rows = Array.isArray(result) ? result : result?.items || [];
    const total = Array.isArray(result) ? null : result?.total;
    let added = 0;
    rows.forEach((row) => {
      const key = row?.id ?? JSON.stringify(row);
      if (seen.has(key)) return;
      seen.add(key);
      items.push(row);
      added += 1;
    });
    if (rows.length < pageSize || added === 0) break;
    if (Number.isFinite(total) && items.length >= total) break;
  }
  return { items, total: items.length };
}
